import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center xl:space-x-6 xl:text-xl space-x-4 text-base" }
const _hoisted_2 = ["data-cy", "onClick"]
const _hoisted_3 = { class: "flex items-center space-x-2" }
const _hoisted_4 = { class: "flex-col flex-no-wrap w-56" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = { class: "flex justify-start flex-wrap text-gray-600" }
const _hoisted_7 = { class: "text-gray-800" }
const _hoisted_8 = { class: "flex flex-col w-46" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-row flex-no-wrap space-x-2"
}
const _hoisted_10 = { class: "text-gray-600" }
const _hoisted_11 = {
  key: 1,
  class: "flex flex-row flex-no-wrap space-x-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600" }, " NHS ", -1)
const _hoisted_13 = { class: "flex flex-col w-46" }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col justify-center px-2"
}
const _hoisted_15 = {
  key: 1,
  class: "flex justify-center px-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MkBadge = _resolveComponent("MkBadge")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResult, (result, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "cursor-pointer select-none",
          "data-cy": result.label,
          onClick: ($event: any) => (_ctx.select(index))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["font-semibold text-xl", _ctx.searchTypeIndex === index ? _ctx.selectedStyle.label : _ctx.unselectedStyle.label])
            }, _toDisplayString(result.label), 3),
            (_ctx.searchTypeIndex === index && _ctx.showPatientResultsTable)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["flex items-center justify-center p-1 text-2xs font-semibold", _ctx.selectedStyle.total])
                }, _toDisplayString(result.rows.length), 3))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_2))
      }), 128))
    ]),
    (_ctx.showPatientResultsTable)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 0,
          loading: _ctx.loading,
          columns: _ctx.columns,
          rows: _ctx.tableRows,
          "custom-heading-style": _ctx.customHeadingStyle,
          "no-data-message": _ctx.$t('custom.uhb.patient.external-lookup-no-patients-found'),
          class: "w-full mt-4"
        }, {
          "cell.patient": _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(`${row.last_name.toUpperCase()}, ${row.first_name}`), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(`${_ctx.getGender(row.gender)}, ${row.age} years (${row.date_of_birth_pretty_short_month})`), 1)
              ])
            ])
          ]),
          "cell.ids": _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_8, [
              (!_ctx.isPDSSearch)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('custom.uhb.patient.mrn-hospital-alias')), 1),
                    _createElementVNode("div", null, _toDisplayString(row.mrn), 1)
                  ]))
                : _createCommentVNode("", true),
              (row.external_patient_references)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", null, _toDisplayString(row.nhs_number), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          "cell.postcode": _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_13, _toDisplayString(row.fhir_address ? row.fhir_address.postalCode : ''), 1)
          ]),
          "cell.buttons": _withCtx(({ row }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["flex justify-end", { 'space-x-2': !row.isMuted }])
            }, [
              (row.deceased_at)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_MkBadge, {
                      color: "gray",
                      size: "small",
                      filled: "",
                      label: 
                _ctx.$t('custom.uhb.patient.deceased-at', {
                  deceasedDate: row.deceased_at_pretty
                })
              
                    }, null, 8, ["label"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_BaseButton, {
                      class: "rounded-lg text-gray-600",
                      color: "ghost",
                      onClick: ($event: any) => (_ctx.$emit('view-patient', row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('platform.common.view')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_BaseButton, {
                      class: "rounded-lg ml-2",
                      color: "ghost",
                      "right-icon": "arrow-right",
                      onClick: ($event: any) => (_ctx.$emit('select-patient', row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('platform.common.select')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
            ], 2)
          ]),
          _: 1
        }, 8, ["loading", "columns", "rows", "custom-heading-style", "no-data-message"]))
      : _createCommentVNode("", true)
  ]))
}